import { Link } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-line">
        <div className="mx-auto flex max-w-[1500px] flex-col gap-8 px-5 py-14 md:flex-row md:items-end md:justify-between md:px-10">
            <div>
                <p className="font-serif text-3xl italic leading-tight text-ink md:text-4xl">
                    Asteraceae of<br />Western Vidarbha
                </p>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-mute" data-testid="footer-author-credit">
                    Compiled by <span className="text-ink">Mayuri R. Kathalkar</span> under the guidance of <span className="text-ink">Prof. Manjusha R. Wath</span>. Doctoral research — not for taxonomic citation without verification.
                </p>
            </div>
            <div className="flex items-center gap-8 font-mono text-[11px] uppercase tracking-[0.22em] text-mute">
                <Link to="/gallery" data-testid="footer-collection-link" className="u-line">Collection</Link>
                <span>72 specimen records</span>
                <button
                    type="button"
                    data-testid="back-to-top-button"
                    onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo(0, 0))}
                    className="flex h-11 w-11 items-center justify-center border border-line text-ink transition-colors duration-300 hover:bg-forest hover:text-paper hover:border-forest"
                    aria-label="Back to top"
                >
                    <ArrowUp className="h-4 w-4" />
                </button>
            </div>
        </div>
    </footer>
);
